import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { getCurrentUserDetail, isLoggedIn } from "../auth";
import Admin from "./admindashboard";
import EmployeeDashboardView from "./employeeDashboardView";

function Dashboard() {
  const [login, setLogin] = useState(false);
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    setLogin(isLoggedIn());
    setUser(getCurrentUserDetail());
  }, [login]);

  const storedData = JSON.parse(localStorage.getItem("data") || "{}");
  const role = user?.role || storedData?.role;

  return (
    <div>
      <Admin />
      {role === "ROLE_EMPLOYEE" && (
        <EmployeeDashboardView user={user || storedData} />
      )}
    </div>
  );
}

export default Dashboard;
